import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { NovaSenha } from "../_models/novaSenha";
import { Grupo, GrupoCreate, GrupoUpdate, Users } from "../_models/users";
import { UserShared } from "../_models/user-shared";

@Injectable({
    providedIn: 'root',
})

export class UsersService {
    constructor(private http: HttpClient) { }

    forgotPassword(model: string): Observable<any> {
        return this.http.post<any>(
            `${environment.URL_API}/User/ForgotPassword`, { login: model });
    }

    resetPassword(model: NovaSenha): Observable<any> {
        return this.http.post<any>(
            `${environment.URL_API}/User/ResetPassword`, model);
    }

    listUsers(): Observable<any> {
        return this.http.get<any>(
            `${environment.URL_API}/User`);
    }

    syncKMM(): Observable<any> {
        return this.http.post<any>(
            `${environment.URL_API}/RouteDetail/SyncKMM`, {});
    }

    getUserId(id: string): Observable<any> {
        return this.http.get<any>(
            `${environment.URL_API}/User/id?id=${id}`);
    }

    create(model: Users): Observable<any> {
        return this.http.post<any>(
            `${environment.URL_API}/User`, model);
    }

    update(model: Users): Observable<any> {
        return this.http.put<any>(
            `${environment.URL_API}/User`, model);
    }

    changeActive(model: Users): Observable<any> {
        return this.http.put<any>(
            `${environment.URL_API}/User/ChangeActive`, model);
    }

    changeApp(model: { id: string; app: boolean }): Observable<any> {
        return this.http.put<any>(
            `${environment.URL_API}/User/ChangeApp`, model);
    }

    changeCancelTrip(model: { id: string; cancelTrip: boolean }): Observable<any> {
        return this.http.put<any>(
            `${environment.URL_API}/User/ChangeCancelTrip`, model);
    }

    changeRefreshChecklist(model: { id: string; refreshChecklist: boolean }): Observable<any> {
        return this.http.put<any>(
            `${environment.URL_API}/User/ChangeRefreshChecklist`, model);
    }

    changeAddDriver(model: { id: string; addDriver: boolean }): Observable<any> {
        return this.http.put<any>(
            `${environment.URL_API}/User/ChangeAddDriver`, model);
    }

    saveCompany(model: any): Observable<any> {
        return this.http.post<any>(
            `${environment.URL_API}/User/Company`, model);
    }

    getCompanyId(id: string): Observable<any> {
        return this.http.get<any>(
            `${environment.URL_API}/User/Company/${id}`);
    }

    saveRouteDetail(model: any): Observable<any> {
        return this.http.post<any>(
            `${environment.URL_API}/User/RouteDetail`, model);
    }

    getRouteDetail(id: string): Observable<any> {
        return this.http.get<any>(
            `${environment.URL_API}/User/RouteDetail/${id}`);
    }

    saveHierarchy(model: any): Observable<any> {
        return this.http.post<any>(
            `${environment.URL_API}/User/Hierarchy`, model);
    }

    getHierarchy(id: string): Observable<any> {
        return this.http.get<any>(
            `${environment.URL_API}/User/Hierarchy/${id}`);
    }

    getManager(): Observable<any> {
        return this.http.get<any>(
            `${environment.URL_API}/User/Manager`);
    }
    getAllSharedByIdUser(idUser: string): Observable<UserShared[]> {
        return this.http.get<UserShared[]>(
            `${environment.URL_API}/usershared/list/${idUser}`);
    }

    getAllGrupos(): Observable<Grupo[]> {
        return this.http.get<Grupo[]>(`${environment.URL_API}/User/Grupo`);
    }

    getGrupoById(idGrupo: string): Observable<any> {
        return this.http.get<any>(`${environment.URL_API}/User/Grupo/${idGrupo}`);
    }

    createGrupo(model: GrupoCreate): Observable<any> {
        return this.http.post<any>(`${environment.URL_API}/User/Grupo/Create`, model);
    }

    updateGrupo(model: GrupoUpdate): Observable<any> {
        return this.http.put<any>(`${environment.URL_API}/User/Grupo`, model);
    }

    deleteGrupo(idGrupo: string): Observable<any> {
        return this.http.delete<any>(`${environment.URL_API}/User/Grupo/${idGrupo}`);
    }

    getGruposByUser(idUser: string): Observable<Grupo[]> {
        return this.http.get<Grupo[]>(`${environment.URL_API}/User/Grupo/User/${idUser}`);
    }

    assignUserToGrupo(model: { idUser: string; grupos: string[]; criadoPor: number }): Observable<any> {
        return this.http.post<any>(`${environment.URL_API}/User/Grupo`, model);
    }

}
